<template>
    <div class="expected-hours" v-if="laborLeft != 0 || cell.expectedHours > 0" :class="{'expected-hours-auto': !ignoreAutoHours && !isLaborApproved}">
      {{  }}
        <template v-if="!ignoreAutoHours && !isLaborApproved">[</template>

        <span :class="{'overlabour': laborLeft < 0}">{{ laborLeftComputed|daysLeftNumber }}</span>

        <template v-if="!ignoreAutoHours && !isLaborApproved">]</template>

        <!-- считаем по подзадачам -->
        <span v-if="diff != 0" :class="{'overlabour': diff > 0}">
          ( {{ diffSign }}{{ diff|daysLeftNumber }})
        </span>
    </div>
</template>

<script>
export default {
    props: ['cell', 'parentCell', 'isSubtask', 'subtasksLaborIntense', 'laborLeft', 'ignoreAutoHours'],
    computed: {
      isLaborApproved() {
        return this.cell.expectedHours > 0 && this.cell.expectedHoursApproved == this.cell.expectedHours
      },
      diff() {
        if (this.isSubtask) {
          if (this.cell.expectedHoursApproved == 0 && !(this.parentCell && this.parentCell.expectedHoursApproved > 0)) {
            return 0
          }
          return (this.cell.expectedHours - this.cell.expectedHoursApproved)/8
        }
        if (this.subtasksLaborIntense > 0) {
          return (this.laborLeft - this.subtasksLaborIntense/8) * -1
        }
        if (this.cell.expectedHoursApproved > 0) {
          return (this.laborLeft - this.cell.expectedHoursApproved/8)
        }
        return 0
      },
      laborLeftComputed() {
        if (this.parentCell && this.parentCell.expectedHoursApproved > 0) {
          return this.cell.expectedHoursApproved/8
        }
        return this.laborLeft
      },
      diffSign() {
        if (this.diff > 0) {
          return '+'
        }
        return ''
      }
    }
}
</script>

<style scoped>
.overlabour {
  font-weight: bold;
  color: #E40231;
}

.expected-hours-auto {
  color: #00254F;
  text-shadow: 1px 1px 2px #FFF, 0px -1px 3px #FFF;
}
</style>